
document.addEventListener('DOMContentLoaded',()=>{

    function isSliderInitialized(){
        let result;
        this.slider = document.querySelector('#tee-gallery');
        if(this.slider){
            result = true;
        }else{
            result = false;
        }

        return result;
    }

    function addInfoBlocks(){
        let textAboveImageElem = document.querySelector('.product-builder-custom-content .text-above-slider');
        let textUnderImageElem = document.querySelector('.product-builder-custom-content .text-under-slider');
        let paymentElements = document.querySelectorAll('.product-builder-custom-content .product__payment-item');
        let slider = document.querySelector('#tee-gallery');
        let productInfoWrapper = document.querySelector('.product__info-wrapper');

        let previewElement = document.querySelector('.product-builder-custom-content .preview-info-label');

        if(slider){

            let sliderInner = document.querySelector('.tee-slider__inner');
            if (previewElement && sliderInner){
                sliderInner.prepend(previewElement);
            }
            
            if(textAboveImageElem){
                let textAboveHTML = textAboveImageElem.outerHTML;
                slider.insertAdjacentHTML('beforebegin', textAboveHTML);
            }

            if(textUnderImageElem){
                let imageWrapper = slider.querySelector('.tee-slide');
                let textUnderHTML = textUnderImageElem.outerHTML;
                slider.querySelector('.tee-slider').insertAdjacentHTML('afterend', textUnderHTML);
                if(imageWrapper){
                    imageWrapper.classList.add('transparent-bg');
                }
            }

            if(paymentElements.length > 0){
                paymentElements.forEach((item)=>{
                    let targetElem = document.querySelector('#teeFormActions');
                    let elemHtml = item.outerHTML;

                    if(targetElem){
                        targetElem.insertAdjacentHTML('beforeend', elemHtml);
                    }
                })
            }



              // SCROLL ELEM
              const image = document.querySelector('.tee-gallery-content');
              let scrollElem = document.createElement('div');
              scrollElem.classList.add('slider-scroll-elem');
              scrollElem.innerHTML = '<div class="slider-scroll-elem__btn"></div>';
              let startY;
              let endY;

              scrollElem.addEventListener("touchstart", function(event) {
                  event.preventDefault();
                  startY = event.touches[0].clientY;
              });

              scrollElem.addEventListener("touchmove", function(event) {
                  event.preventDefault();
                  endY = event.touches[0].clientY;
              });

              scrollElem.addEventListener("touchend", function(event) {
                event.preventDefault();
                  if (startY > endY + 50) {
                      toUp();
                  } else if (startY < endY - 50) {
                      toDown();
                  }
              });

              function toUp() {
                  image.classList.add('resized');

                  for(let i = 1; i <= 42; i++){
                    setTimeout(()=>{
                        image.style.width = `${100 - i}%`;
                        window.dispatchEvent(new Event('resize'));
                    },5 * i)
                  }
                    // image.style.width = '58%';
                    // window.dispatchEvent(new Event('resize'));
              }

              function toDown() {
                  image.classList.add('resized');

                  for(let i = 1; i <= 42; i++){
                    setTimeout(()=>{
                        image.style.width = `${58 + i}%`;
                        window.dispatchEvent(new Event('resize'));
                    },5 * i)
                  }
                //   image.style.width = '100%';
                //   window.dispatchEvent(new Event('resize'));
              }
              slider.parentNode.insertAdjacentElement('beforeend', scrollElem);
        }

        if(productInfoWrapper){
            // main-product.liquid already renders it here, so the title doesn't jump (PET-87).
            if(textUnderImageElem && !productInfoWrapper.querySelector(':scope > .text-under-slider')){
                let textUnderHTML = textUnderImageElem.outerHTML;
                productInfoWrapper.insertAdjacentHTML('afterbegin', textUnderHTML);
            }
        }
    }

    function addScrollAnimation(){
        // SCROLL ANIMATION
        const image = document.querySelector('.tee-gallery-content');

        window.addEventListener('scroll', (event) => {
            if(window.innerWidth <= 750 && document.body.classList.contains('new-builder-design')){
                const scrollY = window.scrollY;
                const teeContainer = document.querySelector('.product--left.product--stacked');
                let maxScroll = 50;
                if (teeContainer && teeContainer.style.getPropertyValue('--tee-gallery-wrapper-top') != '') maxScroll = 25;
                const minWidth = 58;

                if (scrollY <= maxScroll) {
                    const newWidth = 100 - (scrollY / maxScroll) * (100 - minWidth);
                    if(!image.classList.contains('resized')){
                        image.style.width = newWidth + '%';
                    }
                } else {
                    if(!image.classList.contains('resized')){
                        image.style.width = minWidth + '%';
                    }
                }
                window.dispatchEvent(new Event('resize'));
            }
        });
    }

    function disableScrollOnImage(){
        let stickyBlock = document.querySelector('.tee-gallery-wrapper');

        if(stickyBlock){
            stickyBlock.addEventListener("touchmove", function(event) {
                const scrollTop = stickyBlock.scrollTop;
                const scrollHeight = stickyBlock.scrollHeight;
                const offsetHeight = stickyBlock.offsetHeight;

                if ((scrollTop === 0 && event.touches[0].clientY > startY) ||
                    (scrollTop + offsetHeight >= scrollHeight && event.touches[0].clientY < startY)) {
                    event.preventDefault();
                }
            });

            let startY;

            stickyBlock.addEventListener("touchstart", function(event) {
                startY = event.touches[0].clientY;
            });
        }
    }

    function addStepItems(){
        let headings = document.querySelectorAll('.tee-field__heading');

        if(headings.length > 0){
            let i = 1;
            headings.forEach((elem)=>{
                let stepElem = elem.querySelector('.step-item');
                let requiredElem = elem.querySelector('.tee-asterisk');

                if(stepElem){
                    stepElem.remove();
                }

                let html = '';
                if(requiredElem){
                    html = `<span class="step-item">Schritt ${i}</span>`;
                }else{
                    html = `<span class="step-item">Schritt ${i} (optional)</span>`;
                }

                elem.insertAdjacentHTML('afterbegin', html);
                i++
            })
        }

        document.dispatchEvent(new CustomEvent('tee-customization-form:add-step'));
    }



    function addMutationObserver(){
        const targetNode = document.getElementById('teeFormInputs');
        const config = {
            attributes: true,
            childList: true,
            subtree: true
        };

        function observeFunction(){
            observer.disconnect();
            addStepItems();
            observer.observe(targetNode, config);
        }

        const observer = new MutationObserver(observeFunction);
        observer.observe(targetNode, config);
    }

    function addCustomFunctionality(){
        let slider = document.querySelector('#tee-gallery');

        let interval = setInterval(()=>{
            let isSlider = isSliderInitialized();
            if(isSlider){
                addInfoBlocks();
                addScrollAnimation();
                //disableScrollOnImage();
                addStepItems();
                addMutationObserver();
                clearInterval(interval);
            }
        },500)
    }

    addCustomFunctionality();
})
